<header>
    <div class="header-row logo-row">
        <img src="/assets/westnetz-icons/logo_black.svg" aria-hidden="true">
    </div>

    <div class="header-row secondary-row">
        <h1 data-qa="tnb-header">
            <a [routerLink]="['/']">
                TNB-Portal TDL
            </a>

            <div class="user-role">
                @if (user$ | async; as profile) {
                    <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
                    @if (profile.netzbetreiberType === 'WESTNETZ') {
                        <small data-qa="loggedin-netzbetreiber-name">
                            Westnetz
                        </small>
                    } @else {
                        <small data-qa="loggedin-netzbetreiber-name">
                            {{ this.selectedTeilgebiet?.name }}
                        </small>
                        @if (profile.teilgebieteInfos?.length > 1) {
                            <small> - </small>
                            <small data-qa="loggedin-netzbetreiber-teilgebiet">
                                {{ this.selectedTeilgebiet?.teilgebiet }}
                            </small>
                        }
                    }
                }
            </div>
        </h1>

      <nav class="tnb-header-menu">
        @if (user$ | async; as profile) {
          <div>
            <button matButton="filled"
                    class="menu-button"
                    [class.menu-open]="menuTrigger.menuOpen"
                    data-qa="menu-button"
                    [matMenuTriggerFor]="menu"
                    #menuTrigger="matMenuTrigger">
              <mat-icon [svgIcon]="menuTrigger.menuOpen ? 'innogy_picto_close' : 'innogy_picto_menu'"></mat-icon>
              {{ menuTrigger.menuOpen ? 'Schließen' : 'Menü' }}
            </button>
            <mat-menu #menu="matMenu" class="main-menu">
              @if (profile.teilgebieteInfos?.length > 1) {
                <button mat-menu-item
                        data-qa="menu-teilgebietsauswahl"
                        [matMenuTriggerFor]="teilgebietSubMenu">
                  <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
                  <span>Teilgebietsauswahl</span>
                </button>
                <hr>
              }
              <a mat-menu-item
                 data-qa="menu-dashboard"
                 routerLinkActive #rla="routerLinkActive"
                 [attr.aria-current]="rla.isActive ? 'page' : null"
                 routerLink="/dashboard">
                <mat-icon svgIcon="innogy_picto_home_large"></mat-icon>
                <span>Dashboard</span>
              </a>
              <a mat-menu-item
                 data-qa="menu-erzeugungsanlage-list"
                 routerLinkActive #rla="routerLinkActive"
                 [attr.aria-current]="rla.isActive ? 'page' : null"
                 [routerLink]="['/erzeugungsanlage/list']">
                <mat-icon svgIcon="innogy_picto_windmill"></mat-icon>
                <span>Erzeuger Liste</span>
              </a>
              @if (profile.netzbetreiberType === 'STADTWERK') {
                <a mat-menu-item
                   data-qa="menu-new-erzeugungsanlage"
                   routerLinkActive #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [routerLink]="['/erzeugungsanlage/list']"
                   [queryParams]="{'createnew':true}"
                   [queryParamsHandling]="'merge'"
                >
                  <mat-icon svgIcon="innogy_picto_c-plus"></mat-icon>
                  <span>Neue Erzeugungsanlage</span>
                </a>
              }
              @if (profile.netzbetreiberType === 'WESTNETZ') {
                <a mat-menu-item
                   data-qa="menu-netzbetreiber-list"
                   routerLinkActive #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [routerLink]="[routingService.netzbetreiberPath]">
                  <mat-icon svgIcon="innogy_picto_pylon"></mat-icon>
                  <span>Netzbetreiber Liste</span>
                </a>
              }
              @if (authenticationService.isWestnetzAdmin(profile)) {
                <a mat-menu-item
                   data-qa="menu-new-netzbetreiber"
                   [routerLink]="[routingService.netzbetreiberPath]"
                   [queryParams]="{'createnew':true, 'openedInSideNav': true}"
                   [queryParamsHandling]="'merge'">
                  <mat-icon svgIcon="innogy_picto_c-plus"></mat-icon>
                  <span>Neuer Netzbetreiber</span>
                </a>
              }
              @if (profile.netzbetreiberType === 'STADTWERK') {
                <a mat-menu-item
                   data-qa="menu-export"
                   (click)="export()"
                >
                  <mat-icon>cloud_upload</mat-icon>
                  <span>Export</span>
                </a>
              }
              @if (profile.netzbetreiberType === 'STADTWERK') {
                <a mat-menu-item
                   data-qa="menu-import"
                   (click)="openImportWizard()"
                >
                  <mat-icon>cloud_download</mat-icon>
                  <span>Import</span>
                </a>
              }
              <a mat-menu-item
                 [routerLink]="[routingService.netzzuordnungPath]"
                 data-qa="menu-netzzuordnungen-list"
                 routerLinkActive #rla="routerLinkActive"
                 [attr.aria-current]="rla.isActive ? 'page' : null">
                <mat-icon>list</mat-icon>
                <span>Netzzuordnungen Liste</span>
              </a>
              <a mat-menu-item
                 data-qa="menu-planwert-list"
                 routerLinkActive #rla="routerLinkActive"
                 [attr.aria-current]="rla.isActive ? 'page' : null"
                 [routerLink]="['/planwert/list']">
                <mat-icon svgIcon="innogy_picto_calendar-date"></mat-icon>
                <span>Planwerte Liste</span>
              </a>
              @if (authenticationService.isWestnetzAdmin(profile)) {
                <a mat-menu-item
                   data-qa="menu-settings"
                   routerLinkActive #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [routerLink]="['/settings']"
                   [queryParamsHandling]="'merge'">
                  <mat-icon svgIcon="innogy_picto_control-panel"></mat-icon>
                  <span>Einstellungen</span>
                </a>
              }
              @if (profile.netzbetreiberType === 'STADTWERK') {
                <a mat-menu-item
                   data-qa="menu-kontaktdaten-westnetz"
                   routerLinkActive #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [routerLink]="['/contact-data']">
                  <mat-icon svgIcon="innogy_picto_person_info"></mat-icon>
                  <span>Ihre Ansprechpartner</span>
                </a>
              }
              @if (profile.netzbetreiberType === 'STADTWERK') {
                <a mat-menu-item
                   data-qa="menu-meine-kontaktdaten"
                   routerLinkActive #rla="routerLinkActive"
                   [attr.aria-current]="rla.isActive ? 'page' : null"
                   [routerLink]="['netzbetreiber','detail']"
                   [queryParams]="{stadtwerkeId: selectedTeilgebiet?.stadtwerkeId, openedInSideNav: false}">
                  <mat-icon svgIcon="innogy_picto_person"></mat-icon>
                  <span>Meine Kontaktdaten</span>
                </a>
              }
              <a mat-menu-item
                 data-qa="menu-logout-button"
                 (click)="logout()">
                <mat-icon svgIcon="innogy_picto_power_on_off"></mat-icon>
                <span>Abmelden</span>
              </a>
            </mat-menu>
            <mat-menu #teilgebietSubMenu="matMenu" class="teilgebiet-menu" xPosition="before">
              @for (teilgebiet of profile.teilgebieteInfos; track teilgebiet.stadtwerkeId) {
                <button mat-menu-item
                        [disabled]="isTeilgebietSelected(teilgebiet)"
                        (click)="selectTeilgebiet(teilgebiet)">
                  {{teilgebiet.teilgebiet}}
                </button>
              }
            </mat-menu>
          </div>
        } @else {
          <button matButton="filled"
                  data-qa="menu-login-button"
                  (click)="login()">
            <mat-icon>launch</mat-icon>
            <span>Zum Login</span>
          </button>
        }
      </nav>
    </div>
</header>
